import messages from '../locales/cs_CZ.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'cs-CZ',
};
export default lang;
